<template>
  <span>
    <base-button
      :icon="isIcon"
      size="sm"
      :disabled="isReadOnly || isPartnerAccount"
      :class="isIcon ? 'btn-link' : 'btn_extra_small btn_info'"
      @click.native="viewItem"
    >
      <slot name="modal-link"></slot>
    </base-button>
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">LINE ITEM</h4>
      <hr />
      <div class="container">
        <label style="padding-top: 10px;">QTY Requested</label>
        <base-input
          type="number"
          min="0"
          name="requestedQuantity"
          v-model="replacementItem.requestedQuantity"
          :disabled="true"
          data-vv-as="Requested Quantity"
          :error="getError('requestedQuantity')"
          v-validate="'required|decimal|min_value:0'"
        ></base-input>

        <label style="padding-top: 10px;">QTY Received</label>
        <base-input
          type="number"
          min="0"
          name="receivedQuantity"
          data-vv-as="Qty Received"
          v-model="replacementItem.receivedQuantity"
          :error="getError('receivedQuantity')"
          v-validate="'required|decimal|min_value:0'"
        ></base-input>

        <label style="padding-top: 10px;">Unit Price</label>
        <base-input
          type="number"
          min="0"
          name="unitPrice"
          v-model="replacementItem.unitPrice"
          :error="getError('unitPrice')"
          data-vv-as="Unit Price"
          v-validate="'required|decimal|min_value:0'"
        ></base-input>
      </div>
      <template slot="footer">
        <div class="container alert_footer">
          <base-button
            type="danger"
            class="alert_footer_button btn_extra_small btn_info mr-4"
            @click.native="modals.classic = false"
          >
            Close
          </base-button>
          <base-button
            type="primary"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="submit"
          >
            Save
          </base-button>
        </div>
      </template>
    </modal>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BaseButton, Modal } from "@/components";
import Util from '../../../../../util/util';

export default {
  name: "replacement-receipt-modal",
  props: {
    id: {
      type: Number,
      default: 0,
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modals: {
        classic: false,
      },
    };
  },
  components: {
    BaseButton,
    Modal,
  },
  computed: {
    ...mapGetters({
      replacementItem: "replacementItem/replacementItem",
      replacementItems: "replacementItem/replacementItems",
      replacementItemErrors: "replacementItem/replacementItemErrors",
      stockClasses: "stockClass/stockClasses",
      stockSubClasses: "stockClass/stockSubClasses",
      unitMeasures: "unitMeasure/unitMeasures",
      orderMetadata: "orderMetadata/orderMetadata",
      isPartnerAccount: "authentication/isPartnerAccount"
    }),
    stockSubClassRule() {
      return this.stockSubClasses.length > 0 ? "required" : "";
    },
  },
  methods: {
    ...mapActions({
      getReplacementItems: "replacementItem/getReplacementItems",
      getReplacementItem: "replacementItem/getReplacementItem",
      getReplacementItemStatus: "replacementItem/getReplacementItemStatus",
      getReplacementItemReceiptStatus: "replacementItemReceipt/getReplacementItemReceiptStatus",
      clearStockSubClass: "replacementItem/clearStockSubClass",
      saveReplacementItem: "replacementItem/saveReplacementItem",
      getStockClasses: "stockClass/getStockClasses",
      getStockSubClasses: "stockClass/getStockSubClasses",
      getUnitMeasures: "unitMeasure/getUnitMeasures",
      getOrderByStatus: "orders/getOrderByStatus",
    }),
    viewItem() {
      let ctx = this;
      ctx.getUnitMeasures();
      ctx.getStockClasses();
      ctx.getReplacementItem(ctx.id).then(() => {
        ctx.modals.classic = true;
      });
    },
    showReplacementReceiptQuantityErrors (response) {
        if(this.replacementItemErrors.length > 0 ) {
          this.modals.classic = false;
          //  this.replacementItemErrors.forEach(error => this.$toast.error(error))
        } else {
          this.getReplacementItems(this.$route.params.id);
          this.modals.classic = false;
        }
        },
    submit(e) {
      let ctx = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          ctx.saveReplacementItem(ctx.$route.params.id).then((response) => {
            ctx.getReplacementItemStatus(ctx.$route.params.id);
            ctx.getReplacementItemReceiptStatus(ctx.$route.params.id).then((res) => {
              ctx.showReplacementReceiptQuantityErrors(response.data);
            });
          });
        } else {
          this.$toast.error("Please fill the form fields first.");
        }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    stockClassOnChange(value) {
      this.clearStockSubClass();
      this.getStockSubClasses(value);
    },
  },
};
</script>
